import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

interface QuickActionButtonsProps {
  options: string[];
  onSelect: (option: string) => void;
  disabled?: boolean;
}

const QuickActionButtons: React.FC<QuickActionButtonsProps> = ({
  options,
  onSelect,
  disabled = false
}) => {
  if (!options || options.length === 0) return null;

  return (
    <div className="flex justify-start mb-4 quick-actions-appear">
      <div className="flex flex-col max-w-md w-full">
        <div className="flex items-center mb-2 text-xs text-gray-500">
          <SparklesIcon className="h-4 w-4 mr-1" />
          <span>Risposte suggerite</span>
        </div>
        <div className="flex flex-wrap gap-2">
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => !disabled && onSelect(option)}
              disabled={disabled}
              className="px-4 py-2 bg-white border-2 border-primary-300 text-primary-700 rounded-lg hover:bg-primary-50 hover:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md"
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActionButtons;
